import { render, staticRenderFns } from "./RoomComponent.vue?vue&type=template&id=07e9fc09&"
import script from "./RoomComponent.vue?vue&type=script&lang=js&"
export * from "./RoomComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports